// import React, { useState, useEffect } from "react";
// // import { FaPlus } from "react-icons/fa";
// import { FiSearch } from "react-icons/fi";
// import axios from "axios";
// import apiKey from "../../../config/apiKey";
// import { Link, useNavigate } from "react-router-dom";
// import { CopyToClipboard } from "react-copy-to-clipboard";
// import { FaCopy } from "react-icons/fa";
// import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
// import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

// function OnlineTution() {
//   const [data, setData] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [showModal, setShowModal] = useState(false);
//   const [showSecondModal, setShowSecondModal] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const teacher = JSON.parse(localStorage.getItem("edo-teacher"));
//   const [topic, setTopic] = useState("");
//   const [startTime, setStartTime] = useState("");
//   const [duration, setDuration] = useState(60);
//   const [selectedStudent, setSelectedStudent] = useState("");
//   const [selectedStudentClass, setSelectedStudentClass] = useState("");
//   const [zoomLink, setZoomLink] = useState("");
//   const [meetingNum, setMeetingNum] = useState("");
//   const [showThirdModal, setShowThirdModal] = useState(false);
//   const [specificLink, setSpecificLink] = useState(""); // State for specific link
//   const [password, setPassword] = useState("");
//   const [mainID, setMainID] = useState("");

//   const userId = teacher ? teacher.teacher.id : "";

//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(true); // Add loading state
//   useEffect(() => {
//     const fetchData = async () => {
//       //setIsLoading(true);; // Start loading before data fetch
//       try {
//         const response = await axios.get(
//           `${apiKey}/api/edolutions/teacher/read-notifications/${userId}`,
//           {
//             headers: {
//               Authorization: `Bearer ${teacher?.token}`,
//             },
//           }
//         );
//         setData(response.data.data);

//       } catch (error) {
//         console.error("Error fetching data:", error);

//       }
//       finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [teacher?.token, userId]);

//   const handleSearch = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1); // Reset to the first page on new search
//   };

//   const [sortOption, setSortOption] = useState("Newest");
//   const handleSortChange = (e) => {
//     setSortOption(e.target.value);
//   };

//   const sortedData = data.sort((a, b) => {
//     if (sortOption === "Newest") {
//       return new Date(b.created_at) - new Date(a.created_at);
//     } else if (sortOption === "Oldest") {
//       return new Date(a.created_at) - new Date(b.created_at);
//     }
//     return 0;
//   });

//   const filteredData = sortedData.filter(
//     (item) =>
//       (item.student_name?.toLowerCase() || "").includes(
//         searchTerm.toLowerCase()
//       ) ||
//       (item.class_name?.toLowerCase() || "").includes(
//         searchTerm.toLowerCase()
//       ) ||
//       (item.subjects?.toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
//       (item.day_name?.toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
//       (item.start_time?.toLowerCase() || "").includes(
//         searchTerm.toLowerCase()
//       ) ||
//       (item.duration?.toLowerCase() || "").includes(searchTerm.toLowerCase())
//   );

//   const totalItems = filteredData.length;
//   const totalPages = Math.ceil(totalItems / itemsPerPage);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(Math.min(Math.max(1, pageNumber), totalPages));
//   };

//   const handleNextPage = () => {
//     setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
//   };

//   const handlePrevPage = () => {
//     setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
//   };

//   const handleItemsPerPageChange = (event) => {
//     const selectedItemsPerPage = parseInt(event.target.value, 10);
//     setItemsPerPage(selectedItemsPerPage);
//     setCurrentPage(1);
//   };

//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
//   const paginatedData = filteredData.slice(startIndex, endIndex);

//   const [isLoading, setIsLoading] = useState(false); // Add isLoading state
//   const handleCreateMeeting = async () => {
//     // setIsLoading(true); // Set loading to true on form submit
//     try {
//       // Create Zoom meeting
//       const response = await axios.post(
//         `${apiKey}/api/edolutions/teacher/create-zoom-meeting`,
//         {
//           topic,
//           start_time: startTime,
//           duration,
//           teacher_id: userId,
//           student_id: selectedStudent,
//           subject: selectedStudentClass,
//           main_ID: mainID,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${teacher?.token}`,
//           },
//         }
//       );

//       const zoomLink = response.data.join_url;
//       // const urlObj = new URL(zoomLink);
//       // const password = urlObj.searchParams.get("pwd");
//       // setPassword(password);
//       // // Extract meetingNumber
//       // const meetingNumber = zoomLink.match(/\/j\/(\d+)/)?.[1];
//       // setMeetingNum(meetingNumber);
//       setZoomLink(zoomLink);
//       setShowSecondModal(true);
//       setShowModal(false);
//       setTopic("");
//       setDuration("");
//       setStartTime("");
//       setSelectedStudent("");
//       setSelectedStudentClass("");
//       setMainID("")

//       // Fetch notifications
//       const notificationResponse = await axios.get(
//         `${apiKey}/api/edolutions/teacher/read-notifications/${userId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${teacher?.token}`,
//           },
//         }
//       );

//       // console.log("Notifications response:", notificationResponse.data);
//       setData(notificationResponse.data.data || []);
//     } catch (error) {
//       console.error(
//         "Error creating Zoom meeting or fetching notifications:",
//         error
//       );
//     }
//     finally {
//       setIsLoading(false); // Reset loading state after the request completes
//     };
//   };

//   const MeetingLink = (link, joinUrl) => {
//     setSpecificLink(link);
//     const zoom_link = joinUrl;
//     const urlObj = new URL(zoom_link);
//     const password = urlObj.searchParams.get("pwd");
//     setPassword(password);
//     // Extract meetingNumber
//     const meetingNumber = zoom_link.match(/\/j\/(\d+)/)?.[1];
//     setMeetingNum(meetingNumber);
//     setShowThirdModal(true);
//   };

//   // Time format
//   function formatTime(time) {
//     let [hours, minutes] = time.split(":");
//     let period = "AM";

//     hours = parseInt(hours, 10);

//     if (hours >= 12) {
//       period = "PM";
//       if (hours > 12) {
//         hours -= 12;
//       }
//     } else if (hours === 0) {
//       hours = 12;
//     }

//     return `${hours}:${minutes} ${period}`;
//   }

//   const [expandedRow, setExpandedRow] = useState(null);

//   const handleToggleDetails = (index) => {
//     setExpandedRow(expandedRow === index ? null : index);
//   };

//   return (
//     <main className="flex  max-sm:max-w-sm mx-auto items-center xl:p-5 sm:p-0 justify-center">
//       <div className="w-full overflow-auto border rounded-3xl shadow-xl p-5">
//         <div className="mt-2">
//           <div className="flex flex-wrap items-center justify-between p-2">
//             <div className="flex justify-between">
//               <p className="text-[22px] font-bold">Online Sessions</p>
//             </div>
//             <div className="flex  flex-wrap gap-2 max-sm:max-w-sm mx-auto items-center">
//               <div className="relative border shadow-md rounded-md flex items-center px-5 py-2">
//                 <FiSearch className="h-5 w-5 absolute text-[#5963F5]" />
//                 <input
//                   type="text"
//                   className="outline-none pl-8"
//                   placeholder="Search"
//                   value={searchTerm}
//                   onChange={handleSearch}
//                 />
//               </div>
//               <div className="relative ml-2">
//                 <select
//                   className="border shadow-md rounded-md cursor-pointer px-5 py-2 outline-none pl-2 pr-8 text-sm"
//                   value={sortOption}
//                   onChange={handleSortChange}
//                 >
//                   <option value="Newest">Sort By: Newest</option>
//                   <option value="Oldest">Sort By: Oldest</option>
//                 </select>
//               </div>
//             </div>
//           </div>

//           <div className="mt-5">

//             <table className="sm:w-full text-sm text-left text-gray-500 border-b table-auto">
//               <thead className="w-2/3 overflow-auto  text-sm text-[#B5B7C0] font-medium border-b">
//                 <tr className="border-b">
//                   <td className="py-5 px-1">Mentee Name</td>
//                   <td className="py-5 px-1">Profession</td>
//                   <td className="py-5 px-1">Specialization</td>
//                   <td className="py-5 px-1">Start Meeting</td>
//                   <td className="py-5 px-1">Create Meeting</td>
//                   <td className="py-5 px-1">Details</td>
//                 </tr>
//               </thead>
//               <tbody className="w-2/3 overflow-auto  text-black text-sm font-medium">
//                 {loading ? (
//                   <tr>
//                     <td colSpan="6" className="py-5 px-1 text-center">
//                       <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-200 bg-opacity-5 backdrop-blur-sm z-50">
//                         <div className="w-12 h-12 border-4 border-t-4 border-gray-200 border-solid rounded-full animate-spin border-t-[#EE5F2B]"></div>
//                         <p className="mt-4 text-lg font-semibold text-[#EE5F2B]">
//                           Cabil...
//                         </p>
//                       </div>
//                     </td>
//                   </tr>
//                 ) : paginatedData.length === 0 ? (
//                   <tr>
//                     <td colSpan="6" className="py-5 px-1 text-center">
//                       <p className="text-gray-500">
//                         No Online Tutoring Available
//                       </p>
//                     </td>
//                   </tr>
//                 ) : (
//                   paginatedData.map((item, index) => (
//                     <React.Fragment key={index}>
//                       <tr className="border-b">
//                         <td className="py-5 px-1">{item.student_name}</td>

//                         <td className="py-5 px-1">{item.class_name}</td>
//                         <td className="py-5 px-1">{item.subjects}</td>

//                    <td className="py-5 px-1">
// {item.duration === "Free demo ( 30 Minutes )" ? (
//   // Free demo — show Link
//   <p
//     className="cursor-pointer bg-slate-200 hover:bg-slate-300 text-center w-fit px-5 rounded-lg py-1"
//     onClick={() => MeetingLink(item.start_url, item.join_url)}
//   >
//     Link
//   </p>
// ) : item.Fee === "unpaid" ? (
//   // Unpaid but NOT demo — show locked
//   <p className="bg-gray-300 text-gray-500 text-center w-fit px-5 rounded-lg py-1 cursor-not-allowed">
//     Locked
//   </p>
// ) : (
//   // Paid — show Link
//   <p
//     className="cursor-pointer bg-slate-200 hover:bg-slate-300 text-center w-fit px-5 rounded-lg py-1"
//     onClick={() => MeetingLink(item.start_url, item.join_url)}
//   >
//     Link
//   </p>
// )}


// </td>



// {item.duration === "Free demo ( 30 Minutes )" ? (
//   // Free demo — allow Create
//   <td
//     className="cursor-pointer"
//     onClick={() => {
//       setShowModal(true);
//       setSelectedStudent(item.student_id);
//       setSelectedStudentClass(item.subjects);
//       setMainID(item.tbl_id);
//       setTopic(item.topic || "Meeting topic");
//       setStartTime(item.timeslot_id || "");
//     }}
//   >
//     <p className=" bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] text-white text-center w-fit px-5 rounded-lg py-1">
//       Free Demo – Create
//     </p>
//   </td>
// ) : item.Fee === "unpaid" ? (
//   // Unpaid but not demo
//   <td><p>Fee not paid</p></td>
// ) : (
//   // Paid — normal Create
//   <td
//     className="cursor-pointer"
//     onClick={() => {
//       setShowModal(true);
//       setSelectedStudent(item.student_id);
//       setSelectedStudentClass(item.subjects);
//       setMainID(item.tbl_id);
//       setTopic(item.topic || "Meeting topic");
//       setStartTime(item.timeslot_id || "");
//     }}
//   >
//     <p className="bg-[#EE5F2B] text-center w-fit px-5 rounded-lg py-1">
//       Create
//     </p>
//   </td>
// )}


//                         <td className="py-5 px-1">
//                           <button
//                             className="text-blue-500 underline "
//                             onClick={() => handleToggleDetails(index)}
//                           >
//                             {expandedRow === index ? (
//                               <>
//                                 <AiOutlineEyeInvisible className="text-lg text-[#EE5F2B]" />{" "}
//                               </>
//                             ) : (
//                               <>
//                                 <AiOutlineEye className="text-lg text-[#EE5F2B]" />
//                               </>
//                             )}
//                           </button>
//                         </td>
//                       </tr>
//                       {expandedRow === index && (
//                         <tr>
//                           <td colSpan="6">
//                             <table className="w-full text-sm text-left text-gray-500 rounded-lg  shadow-lg table-auto ">
//                               <thead className="text-sm text-white ext-white bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]  font-medium">
//                                 <tr>
//                                   <td className="py-3 px-1">Day</td>
//                                   <td className="py-3 px-1">Timing</td>
//                                   <td className="py-3 px-1">Duration</td>
//                                   <td className="py-3 px-1">Payment</td>

//                                 </tr>
//                               </thead>
//                               <tbody className="text-black text-sm font-medium">
//                                 <tr className="">
//                                   <td className="py-5 px-1 capitalize">
//                                     {item.day_name
//                                       ? item.day_name
//                                       : "Not Defined"}
//                                   </td>
//                                   <td className="py-5 px-1">
//                                     {item.start_time && item.end_time
//                                       ? `${formatTime(
//                                         item.start_time
//                                       )} to ${formatTime(item.end_time)}`
//                                       : item.timeslot_id}
//                                   </td>
//                                   <td className="py-5 px-1">
//                                     {item.days} {item.duration}
//                                   </td>
//                                   <td className="py-5 px-1">
//                                     Rs.{item.payment}
//                                   </td>

//                                 </tr>
//                               </tbody>
//                             </table>
//                           </td>
//                         </tr>
//                       )}
//                     </React.Fragment>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>

//           <div className="flex flex-wrap gap-5 justify-between items-center w-full text-sm mt-4 pb-4 px-2">
//             <div className="flex items-center gap-x-2 text-gray-400">
//               <span>
//                 <select
//                   className="text-sm border-none text-black bg-[#F5F5F5] rounded-lg"
//                   value={itemsPerPage}
//                   onChange={handleItemsPerPageChange}
//                 >
//                   {[10, 20, 30, 40, 50, 100].map((perPage) => (
//                     <option key={perPage} value={perPage}>
//                       {perPage}
//                     </option>
//                   ))}
//                 </select>
//               </span>
//               <span>Showing Data</span>
//               <span>
//                 {startIndex + 1}-{endIndex} of {totalItems} Entries
//               </span>
//             </div>
//             <div className="flex items-center gap-x-2 text-gray-400">
//               <button
//                 className="text-base text-black bg-[#F5F5F5] rounded-lg px-2 py-1"
//                 onClick={handlePrevPage}
//                 disabled={currentPage === 1}
//               >
//                 <MdKeyboardArrowLeft />
//               </button>
//               <div className="flex items-center gap-x-2 text-gray-400">
//                 {[...Array(Math.min(5, totalPages || 1))].map((_, index) => {
//                   const pageNumber = Math.max(currentPage - 2 + index, 1);
//                   const isActive = pageNumber === currentPage;
//                   return (
//                     <button
//                       key={pageNumber}
//                       className={`text-base rounded-lg px-3 py-1 ${isActive
//                           ? "text-white bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]"
//                           : "text-black bg-[#F5F5F5]"
//                         }`}
//                       onClick={() => handlePageChange(pageNumber)}
//                       disabled={pageNumber < 1 || pageNumber > totalPages}
//                     >
//                       {pageNumber}
//                     </button>
//                   );
//                 })}
//                 <span>of {totalPages || 1} pages</span>
//               </div>
//               <button
//                 className="text-base text-black bg-[#F5F5F5] rounded-lg px-2 py-1"
//                 onClick={handleNextPage}
//                 disabled={currentPage === totalPages}
//               >
//                 <MdKeyboardArrowRight />
//               </button>
//             </div>
//           </div>

//           {/* 1st Modal */}
//           {showModal && (
//             <>
//               <div className="fixed inset-0 bg-black bg-opacity-50 z-40" />
//               <div className="fixed inset-0 flex items-center justify-center z-50">
//                 <div className="bg-white rounded-lg shadow-lg max-w-md w-full mx-4 md:mx-0 transition-transform transform scale-95">
//                   <div className="flex justify-between items-center p-4 border-b border-gray-200">
//                     <h2 className="text-xl font-semibold">
//                       Enter Session Details
//                     </h2>
//                     <button
//                       className="text-2xl text-gray-600 hover:text-gray-800"
//                       onClick={() => setShowModal(false)}
//                     >
//                       ×
//                     </button>
//                   </div>
//                   <div className="p-6">
//                     <div className="mb-4">
//                       <input
//                         type="text"
//                         className="w-full p-3 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
//                         value={topic}
//                         onChange={(e) => setTopic(e.target.value)}
//                         placeholder="Meeting Topic"
//                         disabled // Disable the input
//                       />
//                     </div>
//                     <div className="mb-4">
//                       <input
//                         type="datetime-local"
//                         className="w-full p-3 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
//                         value={startTime}
//                         onChange={(e) => setStartTime(e.target.value)}
//                         placeholder="Start Time"
//                       />
//                     </div>
//                     <div className="mb-4">
//                       <input
//                         type="text"
//                         className="w-full p-3 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
//                         value={duration}
//                         onChange={(e) => setDuration(e.target.value)}
//                         placeholder="Duration (minutes)"
//                         disabled
//                       />
//                     </div>
//                     <div className="text-center">
//                       <button
//                         className={`px-6 py-2 bg-blue-500 text-white font-semibold rounded-lg shadow-md hover:bg-blue-600 transition duration-300 ${isLoading ? "opacity-50 cursor-not-allowed" : ""
//                           }`}
//                         onClick={handleCreateMeeting}
//                         disabled={isLoading} // Disable button when loading
//                       >
//                         {isLoading ? (
//                           <svg
//                             className="animate-spin h-5 w-5 text-white mx-auto"
//                             xmlns="http://www.w3.org/2000/svg"
//                             fill="none"
//                             viewBox="0 0 24 24"
//                           >
//                             <circle
//                               className="opacity-25"
//                               cx="12"
//                               cy="12"
//                               r="10"
//                               stroke="currentColor"
//                               strokeWidth="4"
//                             ></circle>
//                             <path
//                               className="opacity-75"
//                               fill="currentColor"
//                               d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                             ></path>
//                           </svg>
//                         ) : (
//                           "Create Zoom Meeting"
//                         )}
//                       </button>

//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </>
//           )}

//           {/* 2nd Modal */}
//           {showSecondModal && (
//             <>
//               <div className="fixed inset-0 bg-black bg-opacity-50 z-40" />
//               <div className="fixed inset-0 flex items-center justify-center z-50">
//                 <div className="bg-white rounded-lg shadow-lg max-w-md w-full mx-4 md:mx-0 transition-transform transform scale-95">
//                   <div className="flex justify-between items-center p-4 border-b border-gray-200">
//                     <h2 className="text-xl font-semibold">Session Zoom Link</h2>
//                     <button
//                       className="text-2xl text-gray-600 hover:text-gray-800"
//                       onClick={() => setShowSecondModal(false)}
//                     >
//                       ×
//                     </button>
//                   </div>
//                   <div className="p-6">
//                     <p className="mb-4 text-sm text-gray-700">
//                       Your Zoomm meeting url for the upcoming session:
//                     </p>
//                     <div className="mb-4 p-4 bg-gray-100 border rounded-md flex items-center">
//                       <a
//                         href={zoomLink}
//                         className="text-blue-600 hover:underline flex-1"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         {zoomLink}
//                       </a>
//                       <CopyToClipboard text={zoomLink}>
//                         <button className="ml-4 text-gray-600 hover:text-gray-800">
//                           <FaCopy size={20} />
//                         </button>
//                       </CopyToClipboard>
//                     </div>
//                     <div className="text-center">
//                       <Link to="/mentor/mentorChat">
//                         <button className="px-6 py-2 bg-blue-500 text-white font-semibold rounded-lg shadow-md hover:bg-blue-600 transition duration-300">
//                           Send to Mentees
//                         </button>
//                       </Link>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </>
//           )}

//           {/* 3rd Modal */}
//           {showThirdModal && (
//             <>
//               <div className="fixed inset-0 bg-black bg-opacity-50 z-40" />
//               <div className="fixed inset-0 flex items-center justify-center z-50">
//                 <div className="bg-white rounded-lg shadow-lg max-w-md w-full mx-4 md:mx-0 transition-transform transform scale-95">
//                   <div className="flex justify-between items-center p-4 border-b border-gray-200">
//                     <h2 className="text-xl font-semibold">Specific Link</h2>
//                     <button
//                       className="text-2xl text-gray-600 hover:text-gray-800"
//                       onClick={() => setShowThirdModal(false)}
//                     >
//                       ×
//                     </button>
//                   </div>
//                   <div className="p-6">
//                     <p className="mb-4 text-sm text-gray-700">
//                       Here is the specific link to start the meeting:
//                     </p>
//                     <div className="mb-4 p-4 bg-gray-100 border rounded-md overflow-hidden">
//                       <a
//                         href={specificLink}
//                         className="text-blue-600 hover:underline break-words"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         {specificLink}
//                       </a>
//                     </div>
//                     <button
//                       className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700"
//                       onClick={() => {
//                         navigate(
//                           `/teacher/ZoomMeetingPage?meetingUrl=${encodeURIComponent(
//                             specificLink
//                           )}&meetingNumber=${meetingNum}&password=${password}`
//                         );
//                       }}
//                     >
//                       Start Meeting
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </>
//           )}
//         </div>
//       </div>
//     </main>
//   );
// }

// export default OnlineTution;


// import React, { useState, useEffect, useMemo } from "react";
// import { FiSearch } from "react-icons/fi";
// import axios from "axios";
// import apiKey from "../../../config/apiKey";
// import { Link, useNavigate } from "react-router-dom";
// import { CopyToClipboard } from "react-copy-to-clipboard";
// import { FaCopy } from "react-icons/fa";
// import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
// import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

// function OnlineTution() {
//   const [data, setData] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [showModal, setShowModal] = useState(false);
//   const [showSecondModal, setShowSecondModal] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const teacher = JSON.parse(localStorage.getItem("edo-teacher"));
//   const [topic, setTopic] = useState("");
//   const [startTime, setStartTime] = useState("");
//   const [duration, setDuration] = useState(60);
//   const [selectedStudent, setSelectedStudent] = useState("");
//   const [selectedStudentClass, setSelectedStudentClass] = useState("");
//   const [zoomLink, setZoomLink] = useState("");
//   const [meetingNum, setMeetingNum] = useState("");
//   const [showThirdModal, setShowThirdModal] = useState(false);
//   const [specificLink, setSpecificLink] = useState("");
//   const [password, setPassword] = useState("");
//   const [mainID, setMainID] = useState("");

//   // 🔹 NEW: keep selected slot info
//   const [selectedDayName, setSelectedDayName] = useState("");
//   const [slotStartTime, setSlotStartTime] = useState(""); // "21:00:00" from API

//   const userId = teacher ? teacher.teacher.id : "";

//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(true);
//   const [isLoading, setIsLoading] = useState(false);
//   const [sortOption, setSortOption] = useState("Newest");
//   const [expandedRow, setExpandedRow] = useState(null);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(
//           `${apiKey}/api/edolutions/teacher/read-notifications/${userId}`,
//           {
//             headers: {
//               Authorization: `Bearer ${teacher?.token}`,
//             },
//           }
//         );
//         setData(response.data.data);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [teacher?.token, userId]);

//   const handleSearch = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleSortChange = (e) => {
//     setSortOption(e.target.value);
//   };

//   const sortedData = [...data].sort((a, b) => {
//     if (sortOption === "Newest") {
//       return new Date(b.created_at) - new Date(a.created_at);
//     } else if (sortOption === "Oldest") {
//       return new Date(a.created_at) - new Date(b.created_at);
//     }
//     return 0;
//   });

//   const filteredData = sortedData.filter((item) =>
//     [
//       item.student_name,
//       item.class_name,
//       item.subjects,
//       item.day_name,
//       item.start_time,
//       item.duration,
//     ]
//       .map((f) => (f || "").toLowerCase())
//       .some((f) => f.includes(searchTerm.toLowerCase()))
//   );

//   const totalItems = filteredData.length;
//   const totalPages = Math.ceil(totalItems / itemsPerPage) || 1;

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(Math.min(Math.max(1, pageNumber), totalPages));
//   };

//   const handleNextPage = () => {
//     setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
//   };

//   const handlePrevPage = () => {
//     setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
//   };

//   const handleItemsPerPageChange = (event) => {
//     const selectedItemsPerPage = parseInt(event.target.value, 10);
//     setItemsPerPage(selectedItemsPerPage);
//     setCurrentPage(1);
//   };

//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
//   const paginatedData = filteredData.slice(startIndex, endIndex);

//   // 🔹 min datetime for <input type="datetime-local"> (no past date/time)
//   const minDateTime = useMemo(() => {
//     const d = new Date();
//     // convert to "local" string for datetime-local
//     d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
//     return d.toISOString().slice(0, 16);
//   }, []);

//   // 🔹 helper: validate selected day/time
//   const dayMap = useMemo(
//     () => ({
//       Sunday: 0,
//       Monday: 1,
//       Tuesday: 2,
//       Wednesday: 3,
//       Thursday: 4,
//       Friday: 5,
//       Saturday: 6,
//     }),
//     []
//   );

//   // const handleStartTimeChange = (e) => {
//   //   const value = e.target.value; // "2025-11-26T21:00"
//   //   if (!value) {
//   //     setStartTime("");
//   //     return;
//   //   }

//   //   const chosen = new Date(value);
//   //   if (Number.isNaN(chosen.getTime())) {
//   //     setStartTime(value);
//   //     return;
//   //   }

//   //   const now = new Date();
//   //   if (chosen < now) {
//   //     alert("Please select a future date & time.");
//   //     return;
//   //   }

//   //   // ✅ restrict weekday
//   //   if (selectedDayName && dayMap[selectedDayName] !== undefined) {
//   //     const requiredDay = dayMap[selectedDayName];
//   //     if (chosen.getDay() !== requiredDay) {
//   //       alert(`Please select only ${selectedDayName} for this session.`);
//   //       return;
//   //     }
//   //   }

//   //   // ✅ restrict time to student's slot start_time (HH:mm)
//   //   if (slotStartTime) {
//   //     const [hh, mm] = slotStartTime.split(":");
//   //     const slotHour = parseInt(hh, 10);
//   //     const slotMin = parseInt(mm, 10);

//   //     if (
//   //       chosen.getHours() !== slotHour ||
//   //       chosen.getMinutes() !== slotMin
//   //     ) {
//   //       alert(
//   //         `Please select time ${formatTime(
//   //           slotStartTime
//   //         )} as per the student's selected slot.`
//   //       );
//   //       return;
//   //     }
//   //   }

//   //   setStartTime(value);
//   // };
// // PURANA function hata do aur ye NEW wala use karo
// const handleStartTimeChange = (e) => {
//   const value = e.target.value; // "2025-11-26T21:00" etc.
//   setStartTime(value);
// };


// const handleCreateMeeting = async () => {
//   // 🔒 VALIDATION YAHAN
//   if (!startTime) {
//     alert("Please select date & time for this session.");
//     return;
//   }

//   const chosen = new Date(startTime);
//   const now = new Date();

//   if (Number.isNaN(chosen.getTime())) {
//     alert("Invalid date/time selected.");
//     return;
//   }

//   // 1) Past time block
//   if (chosen < now) {
//     alert("Please select a future date & time.");
//     return;
//   }

//   // 2) Sirf student's selected day allow
//   if (selectedDayName && dayMap[selectedDayName] !== undefined) {
//     const requiredDay = dayMap[selectedDayName]; // e.g. Monday -> 1
//     if (chosen.getDay() !== requiredDay) {
//       alert(`Please select only ${selectedDayName} for this session.`);
//       return;
//     }
//   }

//   // 3) Optional: exact time slot lock
//   if (slotStartTime) {
//     const [hh, mm] = slotStartTime.split(":");
//     const slotHour = parseInt(hh, 10);
//     const slotMin = parseInt(mm, 10);

//     if (chosen.getHours() !== slotHour || chosen.getMinutes() !== slotMin) {
//       alert(
//         `Please select time ${formatTime(
//           slotStartTime
//         )} as per the student's selected slot.`
//       );
//       return;
//     }
//   }

//   // ========== AGAY WALA TUMHARA PURANA CODE AS-IS ==========
//   setIsLoading(true);
//   try {
//     const response = await axios.post(
//       `${apiKey}/api/edolutions/teacher/create-zoom-meeting`,
//       {
//         topic,
//         start_time: startTime,
//         duration,
//         teacher_id: userId,
//         student_id: selectedStudent,
//         subject: selectedStudentClass,
//         main_ID: mainID,
//       },
//       {
//         headers: {
//           Authorization: `Bearer ${teacher?.token}`,
//         },
//       }
//     );

//     const zoomLink = response.data.join_url;
//     setZoomLink(zoomLink);
//     setShowSecondModal(true);
//     setShowModal(false);
//     setTopic("");
//     setDuration("");
//     setStartTime("");
//     setSelectedStudent("");
//     setSelectedStudentClass("");
//     setMainID("");
//     setSelectedDayName("");
//     setSlotStartTime("");

//     const notificationResponse = await axios.get(
//       `${apiKey}/api/edolutions/teacher/read-notifications/${userId}`,
//       {
//         headers: {
//           Authorization: `Bearer ${teacher?.token}`,
//         },
//       }
//     );
//     setData(notificationResponse.data.data || []);
//   } catch (error) {
//     console.error(
//       "Error creating Zoom meeting or fetching notifications:",
//       error
//     );
//   } finally {
//     setIsLoading(false);
//   }
// };

//   const MeetingLink = (link, joinUrl) => {
//     setSpecificLink(link);
//     const zoom_link = joinUrl;
//     const urlObj = new URL(zoom_link);
//     const password = urlObj.searchParams.get("pwd");
//     setPassword(password);
//     const meetingNumber = zoom_link.match(/\/j\/(\d+)/)?.[1];
//     setMeetingNum(meetingNumber);
//     setShowThirdModal(true);
//   };

//   // Time format for display
//   function formatTime(time) {
//     let [hours, minutes] = time.split(":");
//     let period = "AM";

//     hours = parseInt(hours, 10);

//     if (hours >= 12) {
//       period = "PM";
//       if (hours > 12) {
//         hours -= 12;
//       }
//     } else if (hours === 0) {
//       hours = 12;
//     }

//     return `${hours}:${minutes} ${period}`;
//   }

//   const handleToggleDetails = (index) => {
//     setExpandedRow(expandedRow === index ? null : index);
//   };

//   return (
//     <main className="flex  max-sm:max-w-sm mx-auto items-center xl:p-5 sm:p-0 justify-center">
//       <div className="w-full overflow-auto border rounded-3xl shadow-xl p-5">
//         <div className="mt-2">
//           <div className="flex flex-wrap items-center justify-between p-2">
//             <div className="flex justify-between">
//               <p className="text-[22px] font-bold">Online Sessions</p>
//             </div>
//             <div className="flex  flex-wrap gap-2 max-sm:max-w-sm mx-auto items-center">
//               <div className="relative border shadow-md rounded-md flex items-center px-5 py-2">
//                 <FiSearch className="h-5 w-5 absolute text-[#5963F5]" />
//                 <input
//                   type="text"
//                   className="outline-none pl-8"
//                   placeholder="Search"
//                   value={searchTerm}
//                   onChange={handleSearch}
//                 />
//               </div>
//               <div className="relative ml-2">
//                 <select
//                   className="border shadow-md rounded-md cursor-pointer px-5 py-2 outline-none pl-2 pr-8 text-sm"
//                   value={sortOption}
//                   onChange={handleSortChange}
//                 >
//                   <option value="Newest">Sort By: Newest</option>
//                   <option value="Oldest">Sort By: Oldest</option>
//                 </select>
//               </div>
//             </div>
//           </div>

//           <div className="mt-5">
//             <table className="sm:w-full text-sm text-left text-gray-500 border-b table-auto">
//               <thead className="w-2/3 overflow-auto  text-sm text-[#B5B7C0] font-medium border-b">
//                 <tr className="border-b">
//                   <td className="py-5 px-1">Mentee Name</td>
//                   <td className="py-5 px-1">Profession</td>
//                   <td className="py-5 px-1">Specialization</td>
//                   <td className="py-5 px-1">Start Meeting</td>
//                   <td className="py-5 px-1">Create Meeting</td>
//                   <td className="py-5 px-1">Details</td>
//                 </tr>
//               </thead>
//               <tbody className="w-2/3 overflow-auto  text-black text-sm font-medium">
//                 {loading ? (
//                   <tr>
//                     <td colSpan="6" className="py-5 px-1 text-center">
//                       <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-200 bg-opacity-5 backdrop-blur-sm z-50">
//                         <div className="w-12 h-12 border-4 border-t-4 border-gray-200 border-solid rounded-full animate-spin border-t-[#EE5F2B]"></div>
//                         <p className="mt-4 text-lg font-semibold text-[#EE5F2B]">
//                           Cabil...
//                         </p>
//                       </div>
//                     </td>
//                   </tr>
//                 ) : paginatedData.length === 0 ? (
//                   <tr>
//                     <td colSpan="6" className="py-5 px-1 text-center">
//                       <p className="text-gray-500">
//                         No Online Tutoring Available
//                       </p>
//                     </td>
//                   </tr>
//                 ) : (
//                   paginatedData.map((item, index) => (
//                     <React.Fragment key={index}>
//                       <tr className="border-b">
//                         <td className="py-5 px-1">{item.student_name}</td>
//                         <td className="py-5 px-1">{item.class_name}</td>
//                         <td className="py-5 px-1">{item.subjects}</td>

//                         <td className="py-5 px-1">
//                           {item.duration === "Free demo ( 30 Minutes )" ? (
//                             <p
//                               className="cursor-pointer bg-slate-200 hover:bg-slate-300 text-center w-fit px-5 rounded-lg py-1"
//                               onClick={() =>
//                                 MeetingLink(item.start_url, item.join_url)
//                               }
//                             >
//                               Link
//                             </p>
//                           ) : item.Fee === "unpaid" ? (
//                             <p className="bg-gray-300 text-gray-500 text-center w-fit px-5 rounded-lg py-1 cursor-not-allowed">
//                               Locked
//                             </p>
//                           ) : (
//                             <p
//                               className="cursor-pointer bg-slate-200 hover:bg-slate-300 text-center w-fit px-5 rounded-lg py-1"
//                               onClick={() =>
//                                 MeetingLink(item.start_url, item.join_url)
//                               }
//                             >
//                               Link
//                             </p>
//                           )}
//                         </td>

//                         {item.duration === "Free demo ( 30 Minutes )" ? (
//                           <td
//                             className="cursor-pointer"
//                             onClick={() => {
//                               setShowModal(true);
//                               setSelectedStudent(item.student_id);
//                               setSelectedStudentClass(item.subjects);
//                               setMainID(item.tbl_id);
//                               setTopic(item.topic || "Meeting topic");

//                               // 🔹 slot info from student selection
//                               setSelectedDayName(item.day_name || "");
//                               setSlotStartTime(item.start_time || "");
//                               setStartTime(""); // teacher will pick date
//                             }}
//                           >
//                             <p className=" bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] text-white text-center w-fit px-5 rounded-lg py-1">
//                               Free Demo – Create
//                             </p>
//                           </td>
//                         ) : item.Fee === "unpaid" ? (
//                           <td>
//                             <p>Fee not paid</p>
//                           </td>
//                         ) : (
//                           <td
//                             className="cursor-pointer"
//                             onClick={() => {
//                               setShowModal(true);
//                               setSelectedStudent(item.student_id);
//                               setSelectedStudentClass(item.subjects);
//                               setMainID(item.tbl_id);
//                               setTopic(item.topic || "Meeting topic");

//                               setSelectedDayName(item.day_name || "");
//                               setSlotStartTime(item.start_time || "");
//                               setStartTime("");
//                             }}
//                           >
//                             <p className="bg-[#EE5F2B] text-center w-fit px-5 rounded-lg py-1">
//                               Create
//                             </p>
//                           </td>
//                         )}

//                         <td className="py-5 px-1">
//                           <button
//                             className="text-blue-500 underline "
//                             onClick={() => handleToggleDetails(index)}
//                           >
//                             {expandedRow === index ? (
//                               <AiOutlineEyeInvisible className="text-lg text-[#EE5F2B]" />
//                             ) : (
//                               <AiOutlineEye className="text-lg text-[#EE5F2B]" />
//                             )}
//                           </button>
//                         </td>
//                       </tr>
//                       {expandedRow === index && (
//                         <tr>
//                           <td colSpan="6">
//                             <table className="w-full text-sm text-left text-gray-500 rounded-lg  shadow-lg table-auto ">
//                               <thead className="text-sm text-white ext-white bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]  font-medium">
//                                 <tr>
//                                   <td className="py-3 px-1">Day</td>
//                                   <td className="py-3 px-1">Timing</td>
//                                   <td className="py-3 px-1">Duration</td>
//                                   <td className="py-3 px-1">Payment</td>
//                                 </tr>
//                               </thead>
//                               <tbody className="text-black text-sm font-medium">
//                                 <tr>
//                                   <td className="py-5 px-1 capitalize">
//                                     {item.day_name
//                                       ? item.day_name
//                                       : "Not Defined"}
//                                   </td>
//                                   <td className="py-5 px-1">
//                                     {item.start_time && item.end_time
//                                       ? `${formatTime(
//                                           item.start_time
//                                         )} to ${formatTime(item.end_time)}`
//                                       : item.timeslot_id}
//                                   </td>
//                                   <td className="py-5 px-1">
//                                     {item.days} {item.duration}
//                                   </td>
//                                   <td className="py-5 px-1">
//                                     Rs.{item.payment}
//                                   </td>
//                                 </tr>
//                               </tbody>
//                             </table>
//                           </td>
//                         </tr>
//                       )}
//                     </React.Fragment>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {/* pagination */}
//           <div className="flex flex-wrap gap-5 justify-between items-center w-full text-sm mt-4 pb-4 px-2">
//             <div className="flex items-center gap-x-2 text-gray-400">
//               <span>
//                 <select
//                   className="text-sm border-none text-black bg-[#F5F5F5] rounded-lg"
//                   value={itemsPerPage}
//                   onChange={handleItemsPerPageChange}
//                 >
//                   {[10, 20, 30, 40, 50, 100].map((perPage) => (
//                     <option key={perPage} value={perPage}>
//                       {perPage}
//                     </option>
//                   ))}
//                 </select>
//               </span>
//               <span>Showing Data</span>
//               <span>
//                 {totalItems === 0
//                   ? "0-0"
//                   : `${startIndex + 1}-${endIndex}`}{" "}
//                 of {totalItems} Entries
//               </span>
//             </div>
//             <div className="flex items-center gap-x-2 text-gray-400">
//               <button
//                 className="text-base text-black bg-[#F5F5F5] rounded-lg px-2 py-1"
//                 onClick={handlePrevPage}
//                 disabled={currentPage === 1}
//               >
//                 <MdKeyboardArrowLeft />
//               </button>
//               <div className="flex items-center gap-x-2 text-gray-400">
//                 {[...Array(Math.min(5, totalPages || 1))].map((_, index) => {
//                   const pageNumber = Math.max(currentPage - 2 + index, 1);
//                   const isActive = pageNumber === currentPage;
//                   return (
//                     <button
//                       key={pageNumber}
//                       className={`text-base rounded-lg px-3 py-1 ${
//                         isActive
//                           ? "text-white bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]"
//                           : "text-black bg-[#F5F5F5]"
//                       }`}
//                       onClick={() => handlePageChange(pageNumber)}
//                       disabled={pageNumber < 1 || pageNumber > totalPages}
//                     >
//                       {pageNumber}
//                     </button>
//                   );
//                 })}
//                 <span>of {totalPages || 1} pages</span>
//               </div>
//               <button
//                 className="text-base text-black bg-[#F5F5F5] rounded-lg px-2 py-1"
//                 onClick={handleNextPage}
//                 disabled={currentPage === totalPages}
//               >
//                 <MdKeyboardArrowRight />
//               </button>
//             </div>
//           </div>

//           {/* 1st Modal */}
//           {showModal && (
//             <>
//               <div className="fixed inset-0 bg-black bg-opacity-50 z-40" />
//               <div className="fixed inset-0 flex items-center justify-center z-50">
//                 <div className="bg-white rounded-lg shadow-lg max-w-md w-full mx-4 md:mx-0 transition-transform transform scale-95">
//                   <div className="flex justify-between items-center p-4 border-b border-gray-200">
//                     <h2 className="text-xl font-semibold">
//                       Enter Session Details
//                     </h2>
//                     <button
//                       className="text-2xl text-gray-600 hover:text-gray-800"
//                       onClick={() => setShowModal(false)}
//                     >
//                       ×
//                     </button>
//                   </div>
//                   <div className="p-6">
//                     <div className="mb-4">
//                       <input
//                         type="text"
//                         className="w-full p-3 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
//                         value={topic}
//                         onChange={(e) => setTopic(e.target.value)}
//                         placeholder="Meeting Topic"
//                         disabled
//                       />
//                     </div>
//                     <div className="mb-4">
//                       <input
//                         type="datetime-local"
//                         className="w-full p-3 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
//                         value={startTime}
//                         min={minDateTime}
//                         onChange={handleStartTimeChange}
//                         placeholder="Start Time"
//                       />
//                       {selectedDayName && (
//                         <p className="text-xs text-gray-500 mt-1">
//                           Allowed day: <b>{selectedDayName}</b> at{" "}
//                           {slotStartTime && formatTime(slotStartTime)}
//                         </p>
//                       )}
//                     </div>
//                     <div className="mb-4">
//                       <input
//                         type="text"
//                         className="w-full p-3 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
//                         value={duration}
//                         onChange={(e) => setDuration(e.target.value)}
//                         placeholder="Duration (minutes)"
//                         disabled
//                       />
//                     </div>
//                     <div className="text-center">
//                       <button
//                         className={`px-6 py-2 bg-blue-500 text-white font-semibold rounded-lg shadow-md hover:bg-blue-600 transition duration-300 ${
//                           isLoading ? "opacity-50 cursor-not-allowed" : ""
//                         }`}
//                         onClick={handleCreateMeeting}
//                         disabled={isLoading}
//                       >
//                         {isLoading ? (
//                           <svg
//                             className="animate-spin h-5 w-5 text-white mx-auto"
//                             xmlns="http://www.w3.org/2000/svg"
//                             fill="none"
//                             viewBox="0 0 24 24"
//                           >
//                             <circle
//                               className="opacity-25"
//                               cx="12"
//                               cy="12"
//                               r="10"
//                               stroke="currentColor"
//                               strokeWidth="4"
//                             ></circle>
//                             <path
//                               className="opacity-75"
//                               fill="currentColor"
//                               d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                             ></path>
//                           </svg>
//                         ) : (
//                           "Create Zoom Meeting"
//                         )}
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </>
//           )}

//           {/* 2nd Modal */}
//           {showSecondModal && (
//             <>
//               <div className="fixed inset-0 bg-black bg-opacity-50 z-40" />
//               <div className="fixed inset-0 flex items-center justify-center z-50">
//                 <div className="bg-white rounded-lg shadow-lg max-w-md w-full mx-4 md:mx-0 transition-transform transform scale-95">
//                   <div className="flex justify-between items-center p-4 border-b border-gray-200">
//                     <h2 className="text-xl font-semibold">Session Zoom Link</h2>
//                     <button
//                       className="text-2xl text-gray-600 hover:text-gray-800"
//                       onClick={() => setShowSecondModal(false)}
//                     >
//                       ×
//                     </button>
//                   </div>
//                   <div className="p-6">
//                     <p className="mb-4 text-sm text-gray-700">
//                       Your Zoom meeting url for the upcoming session:
//                     </p>
//                     <div className="mb-4 p-4 bg-gray-100 border rounded-md flex items-center">
//                       <a
//                         href={zoomLink}
//                         className="text-blue-600 hover:underline flex-1"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         {zoomLink}
//                       </a>
//                       <CopyToClipboard text={zoomLink}>
//                         <button className="ml-4 text-gray-600 hover:text-gray-800">
//                           <FaCopy size={20} />
//                         </button>
//                       </CopyToClipboard>
//                     </div>
//                     <div className="text-center">
//                       <Link to="/mentor/mentorChat">
//                         <button className="px-6 py-2 bg-blue-500 text-white font-semibold rounded-lg shadow-md hover:bg-blue-600 transition duration-300">
//                           Send to Mentees
//                         </button>
//                       </Link>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </>
//           )}

//           {/* 3rd Modal */}
//           {showThirdModal && (
//             <>
//               <div className="fixed inset-0 bg-black bg-opacity-50 z-40" />
//               <div className="fixed inset-0 flex items-center justify-center z-50">
//                 <div className="bg-white rounded-lg shadow-lg max-w-md w-full mx-4 md:mx-0 transition-transform transform scale-95">
//                   <div className="flex justify-between items-center p-4 border-b border-gray-200">
//                     <h2 className="text-xl font-semibold">Specific Link</h2>
//                     <button
//                       className="text-2xl text-gray-600 hover:text-gray-800"
//                       onClick={() => setShowThirdModal(false)}
//                     >
//                       ×
//                     </button>
//                   </div>
//                   <div className="p-6">
//                     <p className="mb-4 text-sm text-gray-700">
//                       Here is the specific link to start the meeting:
//                     </p>
//                     <div className="mb-4 p-4 bg-gray-100 border rounded-md overflow-hidden">
//                       <a
//                         href={specificLink}
//                         className="text-blue-600 hover:underline break-words"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         {specificLink}
//                       </a>
//                     </div>
//                     <button
//                       className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700"
//                       onClick={() => {
//                         navigate(
//                           `/mentor/ZoomMeetingPage?meetingUrl=${encodeURIComponent(
//                             specificLink
//                           )}&meetingNumber=${meetingNum}&password=${password}`
//                         );
//                       }}
//                     >
//                       Start Meeting
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </>
//           )}
//         </div>
//       </div>
//     </main>
//   );
// }

// export default OnlineTution;


import React, { useState, useEffect, useMemo } from "react";
import { FiSearch } from "react-icons/fi";
import axios from "axios";
import apiKey from "../../../config/apiKey";
import { Link, useNavigate } from "react-router-dom";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { FaCopy } from "react-icons/fa";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useTranslation } from "react-i18next";

function OnlineTution() {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showSecondModal, setShowSecondModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const teacher = JSON.parse(localStorage.getItem("edo-teacher"));
  const [topic, setTopic] = useState("");
  const [startTime, setStartTime] = useState("");
  const [duration, setDuration] = useState(60);
  const [selectedStudent, setSelectedStudent] = useState("");
  const [selectedStudentClass, setSelectedStudentClass] = useState("");
  const [zoomLink, setZoomLink] = useState("");
  const [meetLink, setMeetLink] = useState("");
  const [meetingNum, setMeetingNum] = useState("");
  const [showThirdModal, setShowThirdModal] = useState(false);
  const [specificLink, setSpecificLink] = useState("");
  const [password, setPassword] = useState("");
  const [mainID, setMainID] = useState("");

  // slot info
  const [selectedDayName, setSelectedDayName] = useState("");
  const [slotStartTime, setSlotStartTime] = useState("");

  const userId = teacher ? teacher.teacher.id : "";

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [sortOption, setSortOption] = useState("Newest");
  const [expandedRow, setExpandedRow] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${apiKey}/api/edolutions/teacher/read-notifications/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${teacher?.token}`,
            },
          }
        );
        setData(response.data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [teacher?.token, userId]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleSortChange = (e) => {
    setSortOption(e.target.value);
  };

  const sortedData = [...data].sort((a, b) => {
    if (sortOption === "Newest") {
      return new Date(b.created_at) - new Date(a.created_at);
    } else if (sortOption === "Oldest") {
      return new Date(a.created_at) - new Date(b.created_at);
    }
    return 0;
  });

  const filteredData = sortedData.filter((item) =>
    [
      item.student_name,
      item.class_name,
      item.subjects,
      item.day_name,
      item.start_time,
      item.duration,
    ]
      .map((f) => (f || "").toLowerCase())
      .some((f) => f.includes(searchTerm.toLowerCase()))
  );

  const totalItems = filteredData.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage) || 1;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(Math.min(Math.max(1, pageNumber), totalPages));
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleItemsPerPageChange = (event) => {
    const selectedItemsPerPage = parseInt(event.target.value, 10);
    setItemsPerPage(selectedItemsPerPage);
    setCurrentPage(1);
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
  const paginatedData = filteredData.slice(startIndex, endIndex);

  // min datetime (no past)
  const minDateTime = useMemo(() => {
    const d = new Date();
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
    return d.toISOString().slice(0, 16);
  }, []);

  const dayMap = useMemo(
    () => ({
      Sunday: 0,
      Monday: 1,
      Tuesday: 2,
      Wednesday: 3,
      Thursday: 4,
      Friday: 5,
      Saturday: 6,
    }),
    []
  );

  // Just store value, validation in handleCreateMeeting
  const handleStartTimeChange = (e) => {
    setStartTime(e.target.value);
  };

  const handleCreateMeeting = async () => {
    // validation
    if (!startTime) {
      alert(t("teacherDash.onlineTution.alertSelectDateTime"));
      return;
    }

    const chosen = new Date(startTime);
    const now = new Date();

    if (Number.isNaN(chosen.getTime())) {
      alert(t("teacherDash.onlineTution.alertInvalidDateTime"));
      return;
    }

    if (chosen < now) {
      alert(t("teacherDash.onlineTution.alertFutureDateTime"));
      return;
    }

    if (selectedDayName && dayMap[selectedDayName] !== undefined) {
      const requiredDay = dayMap[selectedDayName];
      if (chosen.getDay() !== requiredDay) {
        alert(t("teacherDash.onlineTution.alertOnlyDay", { day: selectedDayName }));
        return;
      }
    }

    if (slotStartTime) {
      const [hh, mm] = slotStartTime.split(":");
      const slotHour = parseInt(hh, 10);
      const slotMin = parseInt(mm, 10);

      if (chosen.getHours() !== slotHour || chosen.getMinutes() !== slotMin) {
        alert(
          t("teacherDash.onlineTution.alertExactSlotTime", { time: formatTime(slotStartTime) })
        );
        return;
      }
    }

    setIsLoading(true);
    try {
      const response = await axios.post(
        `${apiKey}/api/edolutions/teacher/create-zoom-meeting`,
        {
          topic,
          start_time: startTime,
          duration,
          teacher_id: userId,
          student_id: selectedStudent,
          subject: selectedStudentClass,
          main_ID: mainID,
          meet_link: meetLink || undefined,
        },
        {
          headers: {
            Authorization: `Bearer ${teacher?.token}`,
          },
        }
      );

      const link = meetLink || response.data.join_url;
      setZoomLink(link);
      setShowSecondModal(true);
      setShowModal(false);
      setTopic("");
      setDuration("");
      setStartTime("");
      setSelectedStudent("");
      setSelectedStudentClass("");
      setMainID("");
      setSelectedDayName("");
      setSlotStartTime("");
      setMeetLink("");

      const notificationResponse = await axios.get(
        `${apiKey}/api/edolutions/teacher/read-notifications/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${teacher?.token}`,
          },
        }
      );
      setData(notificationResponse.data.data || []);
    } catch (error) {
      console.error(
        "Error creating Zoom meeting or fetching notifications:",
        error
      );
    } finally {
      setIsLoading(false);
    }
  };

  const MeetingLink = (link, joinUrl) => {
    setSpecificLink(link);
    const zoom_link = joinUrl;
    const urlObj = new URL(zoom_link);
    const password = urlObj.searchParams.get("pwd");
    setPassword(password);
    const meetingNumber = zoom_link.match(/\/j\/(\d+)/)?.[1];
    setMeetingNum(meetingNumber);
    setShowThirdModal(true);
  };

  function formatTime(time) {
    let [hours, minutes] = time.split(":");
    let period = "AM";

    hours = parseInt(hours, 10);

    if (hours >= 12) {
      period = "PM";
      if (hours > 12) {
        hours -= 12;
      }
    } else if (hours === 0) {
      hours = 12;
    }

    return `${hours}:${minutes} ${period}`;
  }

  const handleToggleDetails = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };

  return (
    <main className="flex  max-sm:max-w-sm mx-auto items-center xl:p-5 sm:p-0 justify-center">
      <div className="w-full overflow-auto border rounded-3xl shadow-xl p-5">
        <div className="mt-2">
          <div className="flex flex-wrap items-center justify-between p-2">
            <div className="flex justify-between">
              <p className="text-[22px] font-bold">{t("teacherDash.onlineTution.title")}</p>
            </div>
            <div className="flex  flex-wrap gap-2 max-sm:max-w-sm mx-auto items-center">
              <div className="relative border shadow-md rounded-md flex items-center px-5 py-2">
                <FiSearch className="h-5 w-5 absolute text-[#5963F5]" />
                <input
                  type="text"
                  className="outline-none pl-8"
                  placeholder={t("teacherDash.common.search")}
                  value={searchTerm}
                  onChange={handleSearch}
                />
              </div>
              <div className="relative ml-2">
                <select
                  className="border shadow-md rounded-md cursor-pointer px-5 py-2 outline-none pl-2 pr-8 text-sm"
                  value={sortOption}
                  onChange={handleSortChange}
                >
                  <option value="Newest">{t("teacherDash.homeTution.sortByNewest")}</option>
                  <option value="Oldest">{t("teacherDash.homeTution.sortByOldest")}</option>
                </select>
              </div>
            </div>
          </div>

          <div className="mt-5">
            <table className="sm:w-full text-sm text-left text-gray-500 border-b table-auto">
              <thead className="w-2/3 overflow-auto  text-sm text-[#B5B7C0] font-medium border-b">
                <tr className="border-b">
                  <td className="py-5 px-1">{t("teacherDash.myStudent.colMenteeName")}</td>
                  <td className="py-5 px-1">{t("teacherDash.myStudent.colProfession")}</td>
                  <td className="py-5 px-1">{t("teacherDash.myStudent.colSpecialization")}</td>
                  <td className="py-5 px-1">{t("teacherDash.onlineTution.colStartMeeting")}</td>
                  <td className="py-5 px-1">{t("teacherDash.onlineTution.colCreateMeeting")}</td>
                  <td className="py-5 px-1">{t("teacherDash.homeTution.colDetails")}</td>
                </tr>
              </thead>
              <tbody className="w-2/3 overflow-auto  text-black text-sm font-medium">
                {loading ? (
                  <tr>
                    <td colSpan="6" className="py-5 px-1 text-center">
                      <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-200 bg-opacity-5 backdrop-blur-sm z-50">
                        <div className="w-12 h-12 border-4 border-t-4 border-gray-200 border-solid rounded-full animate-spin border-t-[#EE5F2B]"></div>
                        <p className="mt-4 text-lg font-semibold text-[#EE5F2B]">
                          {t("teacherDash.homeTution.loadingText")}
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : paginatedData.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="py-5 px-1 text-center">
                      <p className="text-gray-500">
                        {t("teacherDash.onlineTution.noData")}
                      </p>
                    </td>
                  </tr>
                ) : (
                  paginatedData.map((item, index) => {
                    const hasLink = !!item.join_url;
                    const isFreeDemo =
                      item.duration === "Free demo ( 30 Minutes )";
                    const isUnpaid = item.Fee === "unpaid";

                    return (
                      <React.Fragment key={index}>
                        <tr className="border-b">
                          <td className="py-5 px-1">{item.student_name}</td>
                          <td className="py-5 px-1">{item.class_name}</td>
                          <td className="py-5 px-1">{item.subjects}</td>

                          {/* START MEETING (LINK) CELL */}
                          <td className="py-5 px-1">
                            {isUnpaid && !hasLink ? (
                              <p className="bg-gray-300 text-gray-500 text-center w-fit px-5 rounded-lg py-1 cursor-not-allowed">
                                {t("teacherDash.onlineTution.locked")}
                              </p>
                            ) : hasLink ? (
                              <p
                                className="cursor-pointer bg-slate-200 hover:bg-slate-300 text-center w-fit px-5 rounded-lg py-1"
                                onClick={() =>
                                  MeetingLink(item.start_url, item.join_url)
                                }
                              >
                                {t("teacherDash.onlineTution.linkLabel")}
                              </p>
                            ) : (
                              <p className="bg-gray-200 text-gray-400 text-center w-fit px-5 rounded-lg py-1 cursor-not-allowed">
                                {t("teacherDash.onlineTution.linkLabel")}
                              </p>
                            )}
                          </td>

                          {/* CREATE MEETING CELL */}
                          {isUnpaid && !hasLink ? (
                            <td>
                              <p className="text-red-500 font-medium">
                                {t("teacherDash.onlineTution.feeNotPaid")}
                              </p>
                            </td>
                          ) : hasLink ? (
                            <td>
                              <p className="bg-gray-200 text-gray-500 text-center w-fit px-5 rounded-lg py-1 cursor-not-allowed">
                                {t("teacherDash.onlineTution.meetingCreated")}
                              </p>
                            </td>
                          ) : (
                            <td
                              className="cursor-pointer"
                              onClick={() => {
                                setShowModal(true);
                                setSelectedStudent(item.student_id);
                                setSelectedStudentClass(item.subjects);
                                setMainID(item.tbl_id);
                                setTopic(item.topic || "Meeting topic");

                                setSelectedDayName(item.day_name || "");
                                setSlotStartTime(item.start_time || "");
                                setStartTime("");
                              }}
                            >
                              <p
                                className={
                                  isFreeDemo
                                    ? "bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] text-white text-center w-fit px-5 rounded-lg py-1"
                                    : "bg-[#EE5F2B] text-white text-center w-fit px-5 rounded-lg py-1"
                                }
                              >
                                {isFreeDemo ? t("teacherDash.onlineTution.freeDemoCreate") : t("teacherDash.onlineTution.createLabel")}
                              </p>
                            </td>
                          )}

                          <td className="py-5 px-1">
                            <button
                              className="text-blue-500 underline "
                              onClick={() => handleToggleDetails(index)}
                            >
                              {expandedRow === index ? (
                                <AiOutlineEyeInvisible className="text-lg text-[#EE5F2B]" />
                              ) : (
                                <AiOutlineEye className="text-lg text-[#EE5F2B]" />
                              )}
                            </button>
                          </td>
                        </tr>
                        {expandedRow === index && (
                          <tr>
                            <td colSpan="6">
                              <table className="w-full text-sm text-left text-gray-500 rounded-lg  shadow-lg table-auto ">
                                <thead className="text-sm text-white ext-white bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]  font-medium">
                                  <tr>
                                    <td className="py-3 px-1">{t("teacherDash.common.day")}</td>
                                    <td className="py-3 px-1">{t("teacherDash.homeTution.timing")}</td>
                                    <td className="py-3 px-1">{t("teacherDash.homeTution.duration")}</td>
                                    <td className="py-3 px-1">{t("teacherDash.common.payment")}</td>
                                  </tr>
                                </thead>
                                <tbody className="text-black text-sm font-medium">
                                  <tr>
                                    <td className="py-5 px-1 capitalize">
                                      {item.day_name
                                        ? item.day_name
                                        : t("teacherDash.homeTution.notDefined")}
                                    </td>
                                    <td className="py-5 px-1">
                                      {item.start_time && item.end_time
                                        ? `${formatTime(
                                            item.start_time
                                          )} to ${formatTime(item.end_time)}`
                                        : item.timeslot_id}
                                    </td>
                                    <td className="py-5 px-1">
                                      {item.days} {item.duration}
                                    </td>
                                    <td className="py-5 px-1">
                                      {t("teacherDash.homeTution.currencyPrefix")}{item.payment}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          {/* pagination */}
          <div className="flex flex-wrap gap-5 justify-between items-center w-full text-sm mt-4 pb-4 px-2">
            <div className="flex items-center gap-x-2 text-gray-400">
              <span>
                <select
                  className="text-sm border-none text-black bg-[#F5F5F5] rounded-lg"
                  value={itemsPerPage}
                  onChange={handleItemsPerPageChange}
                >
                  {[10, 20, 30, 40, 50, 100].map((perPage) => (
                    <option key={perPage} value={perPage}>
                      {perPage}
                    </option>
                  ))}
                </select>
              </span>
              <span>{t("teacherDash.homeTution.showingData")}</span>
              <span>
                {t("teacherDash.myStudent.entriesRangeValue", { range: totalItems === 0 ? "0-0" : `${startIndex + 1}-${endIndex}`, total: totalItems })}
              </span>
            </div>
            <div className="flex items-center gap-x-2 text-gray-400">
              <button
                className="text-base text-black bg-[#F5F5F5] rounded-lg px-2 py-1"
                onClick={handlePrevPage}
                disabled={currentPage === 1}
              >
                <MdKeyboardArrowLeft />
              </button>
              <div className="flex items-center gap-x-2 text-gray-400">
                {[...Array(Math.min(5, totalPages || 1))].map((_, index) => {
                  const pageNumber = Math.max(currentPage - 2 + index, 1);
                  const isActive = pageNumber === currentPage;
                  return (
                    <button
                      key={pageNumber}
                      className={`text-base rounded-lg px-3 py-1 ${
                        isActive
                          ? "text-white bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]"
                          : "text-black bg-[#F5F5F5]"
                      }`}
                      onClick={() => handlePageChange(pageNumber)}
                      disabled={pageNumber < 1 || pageNumber > totalPages}
                    >
                      {pageNumber}
                    </button>
                  );
                })}
                <span>{t("teacherDash.homeTution.pagesOf", { count: totalPages || 1 })}</span>
              </div>
              <button
                className="text-base text-black bg-[#F5F5F5] rounded-lg px-2 py-1"
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
              >
                <MdKeyboardArrowRight />
              </button>
            </div>
          </div>

          {/* 1st Modal */}
          {showModal && (
            <>
              <div className="fixed inset-0 bg-black bg-opacity-50 z-40" />
              <div className="fixed inset-0 flex items-center justify-center z-50">
                <div className="bg-white rounded-lg shadow-lg max-w-md w-full mx-4 md:mx-0 transition-transform transform scale-95">
                  <div className="flex justify-between items-center p-4 border-b border-gray-200">
                    <h2 className="text-xl font-semibold">
                      {t("teacherDash.onlineTution.enterSessionDetails")}
                    </h2>
                    <button
                      className="text-2xl text-gray-600 hover:text-gray-800"
                      onClick={() => setShowModal(false)}
                    >
                      ×
                    </button>
                  </div>
                  <div className="p-6">
                    <div className="mb-4">
                      <input
                        type="text"
                        className="w-full p-3 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={topic}
                        onChange={(e) => setTopic(e.target.value)}
                        placeholder={t("teacherDash.onlineTution.meetingTopicPlaceholder")}
                        disabled
                      />
                    </div>
                    <div className="mb-4">
                      <input
                        type="datetime-local"
                        className="w-full p-3 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={startTime}
                        min={minDateTime}
                        onChange={handleStartTimeChange}
                        placeholder="Start Time"
                      />
                      {selectedDayName && (
                        <p className="text-xs text-gray-500 mt-1">
                          {t("teacherDash.onlineTution.allowedDayLabel")} <b>{selectedDayName}</b> {t("teacherDash.onlineTution.atLabel")}{" "}
                          {slotStartTime && formatTime(slotStartTime)}
                        </p>
                      )}
                    </div>
                    <div className="mb-4">
                      <input
                        type="text"
                        className="w-full p-3 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={duration}
                        onChange={(e) => setDuration(e.target.value)}
                        placeholder={t("teacherDash.onlineTution.durationPlaceholder")}
                        disabled
                      />
                    </div>
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700 mb-1">{t("teacherDash.onlineTution.googleMeetLabel")}</label>
                      <input
                        type="url"
                        className="w-full p-3 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-green-500"
                        value={meetLink}
                        onChange={(e) => setMeetLink(e.target.value)}
                        placeholder={t("teacherDash.onlineTution.meetLinkPlaceholder")}
                      />
                      <p className="text-xs text-gray-400 mt-1">{t("teacherDash.onlineTution.meetLinkHint")}</p>
                    </div>
                    <div className="text-center">
                      <button
                        className={`px-6 py-2 bg-blue-500 text-white font-semibold rounded-lg shadow-md hover:bg-blue-600 transition duration-300 ${
                          isLoading ? "opacity-50 cursor-not-allowed" : ""
                        }`}
                        onClick={handleCreateMeeting}
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <svg
                            className="animate-spin h-5 w-5 text-white mx-auto"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            ></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                          </svg>
                        ) : (
                          t("teacherDash.onlineTution.createZoomMeeting")
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* 2nd Modal */}
          {showSecondModal && (
            <>
              <div className="fixed inset-0 bg-black bg-opacity-50 z-40" />
              <div className="fixed inset-0 flex items-center justify-center z-50">
                <div className="bg-white rounded-lg shadow-lg max-w-md w-full mx-4 md:mx-0 transition-transform transform scale-95">
                  <div className="flex justify-between items-center p-4 border-b border-gray-200">
                    <h2 className="text-xl font-semibold">{t("teacherDash.onlineTution.sessionZoomLinkTitle")}</h2>
                    <button
                      className="text-2xl text-gray-600 hover:text-gray-800"
                      onClick={() => setShowSecondModal(false)}
                    >
                      ×
                    </button>
                  </div>
                  <div className="p-6">
                    <p className="mb-4 text-sm text-gray-700">
                      {t("teacherDash.onlineTution.zoomUrlIntro")}
                    </p>
                    <div className="mb-4 p-4 bg-gray-100 border rounded-md flex items-center">
                      <a
                        href={zoomLink}
                        className="text-blue-600 hover:underline flex-1"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {zoomLink}
                      </a>
                      <CopyToClipboard text={zoomLink}>
                        <button className="ml-4 text-gray-600 hover:text-gray-800">
                          <FaCopy size={20} />
                        </button>
                      </CopyToClipboard>
                    </div>
                    <div className="text-center">
                      {/* <Link to="/mentor/mysessions">
                        <button className="px-6 py-2 bg-blue-500 text-white font-semibold rounded-lg shadow-md hover:bg-blue-600 transition duration-300">
                          Send to Mentees
                        </button>
                      </Link> */}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* 3rd Modal */}
          {showThirdModal && (
            <>
              <div className="fixed inset-0 bg-black bg-opacity-50 z-40" />
              <div className="fixed inset-0 flex items-center justify-center z-50">
                <div className="bg-white rounded-lg shadow-lg max-w-md w-full mx-4 md:mx-0 transition-transform transform scale-95">
                  <div className="flex justify-between items-center p-4 border-b border-gray-200">
                    <h2 className="text-xl font-semibold">{t("teacherDash.onlineTution.specificLinkTitle")}</h2>
                    <button
                      className="text-2xl text-gray-600 hover:text-gray-800"
                      onClick={() => setShowThirdModal(false)}
                    >
                      ×
                    </button>
                  </div>
                  <div className="p-6">
                    <p className="mb-4 text-sm text-gray-700">
                      {t("teacherDash.onlineTution.specificLinkIntro")}
                    </p>
                    <div className="mb-4 p-4 bg-gray-100 border rounded-md overflow-hidden">
                      <a
                        href={specificLink}
                        className="text-blue-600 hover:underline break-words"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {specificLink}
                      </a>
                    </div>
                    <button
                      className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700"
                      onClick={() => {
                        navigate(
                          `/mentor/zoom-meeting-page?meetingUrl=${encodeURIComponent(
                            specificLink
                          )}&meetingNumber=${meetingNum}&password=${password}`
                        );
                      }}
                    >
                      {t("teacherDash.onlineTution.startMeetingButton")}
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </main>
  );
}

export default OnlineTution;
